declare var Card: any;
namespace AgerLMS.WebSite {

    export interface CartPageWidgetRequest {
        cartCargoId?: number;
    }

    @Serenity.Decorators.registerClass()
    export class CartPageWidget extends Serenity.Widget<CartPageWidgetRequest> {

        constructor(element: JQuery, opt: CartPageWidgetRequest) {
            super(element, opt);

            var self = this;

            $(".cart-quantity .minus").click(function () {
                var $input = $(this).parent().find('input');
                var count = parseInt($input.val()) - 1;
                count = count < 1 ? 1 : count;
                $input.val(count);
                $input.change();
                return false;
            });

            $(".cart-quantity .plus").click(function () {
                var $input = $(this).parent().find('input');
                $input.val(parseInt($input.val()) + 1);
                $input.change();
                return false;
            });

            $(".cart-quantity input").change(function () {
                var $input = $(this);
                var cartKey = $input.data("key");

                LMS.ShoppingCartService.Update({ Entity: { CartKey : cartKey, Quantity: Q.toId($input.val()) } }, response => {
                    window.location.reload();
                }, {
                    onError: response => {
                        SweetAlert.swal_alert("Hata", response.Error.Message);
                    }
                });
            });

            $("#DeleteDiscountId").click(function (e) {
                e.preventDefault();
                LMS.ShoppingCartService.SetCartDiscount({
                }, response => {
                    window.location.reload();                            
                });
            });

            $("#checkCoupon").click(function(e) {
                e.preventDefault();
                self.checkDiscountCode();
            });
            this.prepareCargoSelect();
        }

        prepareCargoSelect() {
            var self = this;
            var cargos = Q.getLookup<LMS.CargoRow>("LMS.Cargos");
            var data = cargos.items.map(x => { return { id: x.Id, text: x.CargoName } });
            let cargoElement = ($("#selectCargo") as any);
            cargoElement.select2({
                placeholder: "Kargo Seçiniz",
                allowClear: true,
                data: data,
            });
            cargoElement.val(self.options.cartCargoId);
            cargoElement.trigger("change");

            cargoElement.on("change", function (e) {
                var cargoId = Q.toId(cargoElement.val());
                LMS.ShoppingCartService.SetCartSelectedCargo({
                    EntityId: cargoId
                }, response => {
                    window.location.reload();                            
                });
            });
        }

        trPriceHtml(price?: any): string {
            price = price || 0;
    
            if (price != null)
                return "<span class='tr-price'>₺</span> " + parseFloat(price).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').replace(/\.(\d+)$/,',$1') 
        }

        checkDiscountCode() {
            SweetAlert.swal_loading('İndirim kodu kontrol ediliyor...');
            var couponCode = $('#coupon_input');
            if (couponCode.val() != '') {
                LMS.DiscountsService.CheckCouponCode({
                    CouponCode: couponCode.val()
                }, response => {
                    SweetAlert.swal_close();
                    SweetAlert.swal_confirm("Onay", "İndirim kodu kontrol edildi. Size " + this.trPriceHtml(response.DiscountAmount) + " indirim yapılacaktır. Onaylıyor musunuz?", () => {
                        LMS.ShoppingCartService.SetCartDiscount({
                            EntityId: response.DiscountId
                        }, response => {
                            window.location.reload();                            
                        });
                    });
                }, {
                    onError: (response) => {
                        SweetAlert.swal_close();
                        SweetAlert.swal_alert("HATA", response.Error.Message);
                        couponCode.val('');
                        couponCode.focus();
                    }
                });
            }

        }

    }
}